import { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserContext } from './UserContext';
import { useNavigate } from "react-router-dom";
import API from './API'
import { Routes, Route, Navigate } from "react-router";
import { ContextType } from './interfaces'
import { NavLink } from "react-router-dom";
import Reporting from './Reporting';
import PersonMonthReport from './PersonMonthReport';
import Persons from './Persons';
import Person from './Person';
import Positions from './Positions';
import Companies from './Companies';
import Centers from './Centers';
import Activities from './Activities'
import Products from './Products'
import Orders from './Orders'
import Projects from './Projects'
import Project from './Project';
import MonthlyReporting from './MonthlyReporting';
import { menuItems } from './constants';
import { IconName } from '@fortawesome/free-solid-svg-icons';
import ProjectOrder from './ProjectOrder';
import Activity from './Activity';
import Product from './Product';
import Company from './Company';
import Position from './Position';
import Center from './Center';
import Division from './Division';
import Setting from './Setting';
import { ModalContext } from './ModalContext';
import UserChangePassword from './Modal/UserChangePassword';

function Dashboard() {
    const navigate = useNavigate();
    const [showModal, closeModal] = useContext(ModalContext);
    const { currentUser, setCurrentUser } = useContext(UserContext) as ContextType;
    const doLogout = () => {
        API.doLogout().then(() => {
            navigate('/login')
        })
    }

    const changePassword = (password: string) => {
        return API.setPassword(password)
    }

    return (
        <div className="mt-1 borders rounded-bottom mb-5">
            <nav className="navbar navbar-expand-lg bg-antracit py-0">
                <div className="container-fluid">
                    <a className="navbar-brand text-white" href="#">Time Report</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarText">
                        <ul className="nav nav-tabs me-auto mb-2 mb-lg-0" style={{ position: 'relative', top: '12px' }} data-bs-theme="white-dark">
                            {
                                menuItems.map(menuItem => {
                                    if (menuItem.visible(currentUser)) {
                                        return (
                                            <li className="nav-item">
                                                <NavLink className="nav-link" to={menuItem.link}><FontAwesomeIcon fixedWidth icon={["fas", menuItem.icon as IconName]} /> {menuItem.text}</NavLink>
                                            </li>
                                        )
                                    } else {
                                        return null
                                    }
                                })
                            }
                        </ul>
                        <span className="navbar-text text-white">
                            <div role="button" onClick={() => showModal(
                                <UserChangePassword
                                    changeFunction={changePassword}
                                />


                            )}> <FontAwesomeIcon fixedWidth icon={["fas", "user-circle"]} /> {currentUser?.name} {currentUser?.surname}</div>
                            <div><small role="button" onClick={doLogout}> <FontAwesomeIcon fixedWidth icon={["fas", "arrow-right-from-bracket"]} /> Logout</small></div>
                        </span>
                    </div>
                </div>
            </nav>

            <Routes>
                <Route path="/" element={<Navigate to="reporting" replace={true} />} />
                
                <Route path="reporting/:year?" element={<Reporting />} />
                <Route path="reporting/:year?/:what?/*" element={<Reporting />} />
                {/* <Route path="reporting/:what/:year/:month/:personId" element={<Reporting />} /> */}
                {/* <Route path="reporting/:year/:month/:personId" element={<PersonMonthReport />} /> */}
                <Route path="project" element={<Projects />} />
                <Route path="project/:projectId" element={<Project />} />
                <Route path="project/:projectId/order/:orderId" element={<ProjectOrder />} />
                <Route path="order" element={<Orders />} />
                <Route path="activity" element={<Activities />} />
                <Route path="activity/:activityId" element={<Activity />} />
                <Route path="person" element={<Persons />} />
                <Route path="person/:personId" element={<Person />} />
                <Route path="product" element={<Products />} />
                <Route path="product/:productId" element={<Product />} />
                <Route path="position" element={<Positions />} />
                <Route path="position/:positionId" element={<Position />} />
                <Route path="company" element={<Companies />} />
                <Route path="company/:companyId" element={<Company />} />
                <Route path="center" element={<Centers />} />
                <Route path="center/center/:centerId" element={<Center />} />
                <Route path="center/division/:divisionId" element={<Division />} />
                <Route path="month" element={<MonthlyReporting />} />
                <Route path="setting" element={<Setting />} />
            </Routes>
        </div>
    )
}

export default Dashboard;